(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["etool-guide-citations"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.etoolGuideCitationsReady) return;
  window.etoolGuideCitationsReady = true;
  function citationTarget(hash) {
    var id;
    try { id = decodeURIComponent((hash || '').replace(/^#/, '')); } catch (error) { return null; }
    if (!id) return null;
    var target = document.getElementById(id);
    if (!target || !target.closest('.etool-guide [data-guide-id]')) return null;
    return target.matches('[data-eg-source], .eg-citation-link') ? target : null;
  }
  function openAncestors(target) {
    var parent = target.parentElement;
    while (parent) {
      if (parent.tagName === 'DETAILS') parent.open = true;
      parent = parent.parentElement;
    }
  }
  function reveal(hash) {
    var target = citationTarget(hash);
    if (!target) return;
    openAncestors(target);
    window.requestAnimationFrame(function () {
      if (citationTarget(location.hash) !== target) return;
      var panel = target.closest('[data-eg-panel]');
      if (panel && panel.hidden) return;
      openAncestors(target);
      target.focus({preventScroll:true});
      target.scrollIntoView({block:'center', behavior:'auto'});
    });
  }
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest('a[data-eg-cite]');
    if (!link || !link.closest('.etool-guide')) return;
    var hash = link.getAttribute('href');
    var target = citationTarget(hash);
    if (!target) return;
    event.preventDefault();
    openAncestors(target);
    if (location.hash !== hash) location.hash = hash;
    reveal(hash);
  });
  window.addEventListener('hashchange', function () { reveal(location.hash); });
  document.addEventListener('shopify:section:load', function () { reveal(location.hash); });
  reveal(location.hash);
}());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["etool-learning-styles"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__etoolLearningSourcesBound) return;
  window.__etoolLearningSourcesBound = true;
  let scheduled = false;
  const findTarget = (hash) => {
    if (!hash || !hash.startsWith('#el-')) return null;
    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch { return null; }
    const target = document.getElementById(id);
    return target && target.closest('.el') ? target : null;
  };
  const reveal = (target) => {
    if (!target) return;
    let ancestor = target.parentElement;
    while (ancestor) {
      if (ancestor.tagName === 'DETAILS') ancestor.open = true;
      ancestor = ancestor.parentElement;
    }
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    target.scrollIntoView({ block: 'start', behavior: 'auto' });
  };
  const revealLocation = () => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => { scheduled = false; reveal(findTarget(window.location.hash)); });
  };
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element ? event.target.closest('.el a[href^="#el-"]') : null;
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname || destination.search !== window.location.search) return;
    const target = findTarget(destination.hash);
    if (!target) return;
    event.preventDefault();
    if (window.location.hash !== destination.hash) window.history.pushState(null, '', destination.hash);
    reveal(target);
  });
  window.addEventListener('hashchange', revealLocation);
  window.addEventListener('popstate', revealLocation);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealLocation, { once: true });
  else revealLocation();
})();
  } catch(e) { console.error(e); }
})();

})();
